import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigsLoaderService} from "./config-loader.service";
import {Item} from "../models/item.inferface";

@Injectable({providedIn: 'root'})
export class DatasourceService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
    ) {
    this.apiUrl = this.config.apiUrl;
  }

  getTenantList() {
    return this.httpClient.get<Item[]>(`${this.apiUrl}/DataSource/GetTenants`);
  }
}
